import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { mySystemSettingsApi } from 'v5/api/system-settings/system-settings.api.connected';
import { createSystemSettingsMutationService } from './SystemSettingsMutationService.impl';

export const mySystemSettingsMutationService =
  createSystemSettingsMutationService({
    api: mySystemSettingsApi,
    queryClient
  });
